module.exports = __webpack_public_path__ + "static/8-8806c44c9df0dc78d3d55b9adb9323d0.jpg";